<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-project-milestone-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Project Milestone
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.name"
                name="name"
                label="Name"
                :error="(errors.name || [])[0]"
            />

            <DateFormGroup
                v-model="data.date"
                name="date"
                label="Date"
                :error="(errors.date || [])[0]"
            />

            <FormGroup
                v-for="(projectMilestoneManager, index) in data.project_milestone_managers"
                :key="index"
                :name="'project_milestone_managers.'+ index+'.user_id'"
                label="Manager"
                :error="(errors['project_milestone_managers.'+ index+'.user_id'] || [])[0]"
            >
              <div class="row">
                <div class="col-xs-18">
                  <SelectWidget
                      v-model="projectMilestoneManager.user_id"
                      :name="'project_milestone_managers.'+ index+'.user_id'"
                      :options="users.map(user => ({value: user.id, label: user.attributes.full_name}))"
                  />
                </div>

                <div class="col-xs-6">
                  <button type="button" class="btn btn-default btn-block" @click="data.project_milestone_managers.splice(index, 1)">
                    Remove
                  </button>
                </div>
              </div>
            </FormGroup>
          </div>

          <div class="modal-footer">
            <div class="pull-left">
              <button type="button" class="btn btn-default" @click="data.project_milestone_managers.push({})">
                Add Manager
              </button>
            </div>

            <div class="pull-right">
              <button type="button" class="btn btn-default" data-dismiss="modal">
                Close
              </button>

              <button type="submit" class="btn btn-black">
                <i class="fa fa-save"></i> Save
              </button>
            </div>

            <div class="clearfix"/>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import Errors from '@/mixins/Errors'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup.vue'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {DateFormGroup, FormGroup, SelectWidget, TextFormGroup},

  mixins: [Errors],

  props: {
    projectMilestone: {
      required: true
    },
  },

  data() {
    return {
      data: {},

      loading: true,

      users: null,
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  watch: {
    projectMilestone() {
      this.data = {
        ...this.projectMilestone.attributes,
        project_milestone_managers: [...this.projectMilestone.attributes.project_milestone_managers]
      }
    }
  },

  methods: {
    load() {
      http.get('/api/v2/users').then(response => {
        this.users = response.data.data

        this.loading = false
      })
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/project-milestones/' + this.projectMilestone.id, this.data)
          .then(response => {
            notify.success('The project milestone was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {
        ...this.projectMilestone.attributes,
        project_milestone_managers: [...this.projectMilestone.attributes.project_milestone_managers]
      }
    }
  }
}
</script>
